export default __webpack_public_path__ + "static/media/goshen71.4fea8013.jpg";